export interface IRequestBody {
    body?: any;
}
export abstract class BaseModel {
    public AsRequestBody(): any {
        return <IRequestBody>{ body: this };
    }
}